import { environment } from 'src/environments/environment';

export type WizardBrandKey = 'default' | 'cncs' | 'solar-rent';

export interface WizardBrandingMetadata {
  key: WizardBrandKey;
  routeSegment: string;
  displayName: string;
  logoSrc: string | null;
  logoAlt: string;
  wordmarkText?: string;
  primaryColor: string;
  primaryColorDark: string;
}

const cncsBranding: WizardBrandingMetadata = {
  key: 'cncs',
  routeSegment: 'cncs',
  displayName: 'CNCS',
  logoSrc: `${environment.cncsCoreUrl}/images/logo.png`,
  logoAlt: 'CNCS',
  primaryColor: '#00206f',
  primaryColorDark: '#293172',
};

export const WIZARD_BRANDING_METADATA: Record<WizardBrandKey, WizardBrandingMetadata> = {
  default: cncsBranding,
  cncs: cncsBranding,
  'solar-rent': {
    key: 'solar-rent',
    routeSegment: 'solar-rent',
    displayName: 'SOLAR RENT',
    logoSrc: `${environment.cncsCoreUrl}/images/logo.png`,
    logoAlt: 'SOLAR RENT',
    wordmarkText: 'SOLAR RENT',
    primaryColor: '#071a2f',
    primaryColorDark: '#051321',
  },
};
